var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBainisteoirLurganVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1831.21 301.23",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M575.19,69.57h84.59v169.8h-169.8V70.19l9.95,4.35,73.39,36.7,1.87.62v-42.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.13,69.61h133.56l9.99,2.5,7.49,3.74,6.24,4.99,4.99,4.99,4.99,8.11,3.12,9.36.62,4.37v8.74l-1.87,9.36-4.99,9.99-6.87,7.49-4.37,3.74-6.87,3.74-6.24,2.5-6.87,1.25h-4.37l33.08,66.16,6.24,11.86,3.12,6.87h-171.01V69.61Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1064.08 239.36 980.44 239.37 980.6 182.87 934.6 182.74 934.56 69.63 1109.74 69.54 1109.94 182.72 1063.85 182.91 1064.08 239.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29,142.8c24.87,6.84,38.2,27.29,36.99,51.39-1.07,21.23-20.58,44.27-45.56,44.46l-95.85.72.02-169.88,91.74-.22c17.61-.04,33.1,13.22,36.44,27.36,4.69,19.86-2.38,35.65-23.78,46.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.38 238.36 188.15 239.37 283.03 64.41 377.38 238.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.77,116.29c28.27,30.02,29.39,74.6,2.83,102.04-29.44,30.42-74.76,32.7-107.83,2.66l31.27-31.88c-28.07-31.26-27.29-74.63-.73-102.07,27.65-28.56,73.82-31.58,106.28-2.47l-31.83,31.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.12,67.22c47.71-1.84,85.62,35.87,88.8,80.3,3.52,49.18-34.68,89.71-82.68,91.76-48.48,2.08-89.64-34.45-91.28-82.96-1.61-47.61,34.19-87.13,85.16-89.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1253.83 182.7 1311.6 182.79 1311.61 239.37 1139.48 239.37 1139.52 69.86 1196.71 69.51 1196.8 126.3 1254.01 126.34 1253.83 182.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1576.76 238.99 1511.53 239.37 1511.52 69.71 1576.67 69.59 1576.76 238.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.97 238.99 394.93 239.37 395.28 69.83 459.88 69.57 459.97 238.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "752.39 238.99 687.36 239.37 687.71 69.83 752.3 69.57 752.39 238.99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBainisteoirLurganVector);
export default __webpack_public_path__ + "static/media/Bainisteoir-Lurgan-Vector.9c23cf222d44aa84519b07b70f325e43.svg";
export { ForwardRef as ReactComponent };